import React from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../../../config/apiConfig";

const RestaurantCard = ({ restaurant, isDashboardView = false }) => {
  const navigate = useNavigate();

  const imageSrc =
    restaurant?.restaurantSettings?.gallery?.length > 0
      ? `${API_URL}/uploads/restaurants/${restaurant._id}/${restaurant.restaurantSettings.gallery[0]}`
      : "/images/default-restaurant.jpg";

  const handleClick = () => {
    if (isDashboardView) {
      // داخل داشبورد، جزئیات داخل همان layout نمایش داده شود
      navigate(`/p/customer/restaurant/${restaurant._id}?dashboard=true`);
    } else {
      // مسیر عمومی
      navigate(`/restaurant/${restaurant._id}`);
    }
  };

  return (
  <div
  onClick={handleClick}
  className="group bg-white rounded-2xl overflow-hidden
             border border-gray-100
             hover:shadow-lg
             transition-all duration-300
             cursor-pointer"
>
  {/* Image */}
  <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
    {imageSrc ? (
      <img
        src={imageSrc}
        alt={restaurant.name}
        className="w-full h-full object-cover
                   group-hover:scale-105
                   transition-transform duration-500"
      />
    ) : (
      <div className="w-full h-full flex items-center justify-center text-gray-400 text-sm">
        بدون تصویر
      </div>
    )}

    {/* Rating */}
    <div className="absolute top-3 left-3
                    bg-white/90 backdrop-blur
                    px-2.5 py-1 rounded-full
                    text-xs font-medium text-gray-800">
      ⭐ {restaurant.rating || "4.5"}
    </div>
  </div>

  {/* Content */}
  <div className="p-4 space-y-2">
    <h3 className="font-semibold text-base text-gray-900 line-clamp-1">
      {restaurant.name}
    </h3>

    {restaurant.address && (
      <p className="text-xs text-gray-500 line-clamp-1">
        {restaurant.address}
      </p>
    )}

    <p className="text-sm text-gray-600 line-clamp-2">
      {restaurant.description || "توضیحات ثبت نشده."}
    </p>

    {/* Price */}
    <div className="flex items-center justify-between pt-3">
      <span className="text-xs text-gray-500">
        رزرو میز
      </span>

      <span className="text-sm font-semibold text-primary">
        {restaurant?.restaurantSettings?.tableReservePrice
          ? `${restaurant?.restaurantSettings?.tableReservePrice} تومان`
          : "نامشخص"}
      </span>
    </div>
  </div>
</div>
  );
};

export default RestaurantCard;
